import { CallSplit } from "@mui/icons-material";
import Build from "@mui/icons-material/Build";
import Comment from "@mui/icons-material/Comment";
import ListIcon from "@mui/icons-material/List";
import { Grid2, IconButton } from "@mui/material";
import { DelayByShift } from "../../models/DelayByShift";

type Props = {
	data: DelayByShift;
	justifyData: (delay: DelayByShift) => void;
	splitData: (delay: DelayByShift) => void;
	adjustment: (delay: DelayByShift) => void;
	showContextMenu: () => void;
};

export const GridButtons = ({
	data,
	justifyData,
	splitData,
	adjustment,
	showContextMenu,
}: Props) => {
	return (
		<Grid2
			container
			sx={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				opacity: 0,
				transition: "opacity 0.1s ease-in-out",
			}}
			className={`buttons`}
		>
			<Grid2
				size={{ md: 12, xs: 12 }}
				style={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
				}}
			>
				<IconButton
					aria-label="justify-icon"
					title="Justify"
					style={{ cursor: "pointer" }}
					onClick={() => justifyData(data)}
				>
					<Comment fontSize="inherit" color="primary" />
				</IconButton>
				<IconButton
					aria-label="split-icon"
					title="Split"
					style={{ cursor: "pointer" }}
					onClick={() => splitData(data)}
				>
					<CallSplit fontSize="inherit" color="primary" />
				</IconButton>
				<IconButton
					aria-label="adjustment-icon"
					title="Adjustment"
					style={{ cursor: "pointer" }}
					onClick={() => adjustment(data)}
					disabled={data.AssetId !== 12}
					color="primary"
				>
					<Build fontSize="inherit" />
				</IconButton>
				<IconButton
					aria-label="Options"
					title="Options"
					style={{ cursor: "pointer" }}
					onClick={showContextMenu}
				>
					<ListIcon
						fontSize="inherit"
						color="primary"
						style={{ cursor: "pointer" }}
					/>
				</IconButton>
			</Grid2>
		</Grid2>
	);
};
